import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";

interface AccessDeniedState {
  attemptedRoute?: string;
  requiredPermission?: string;
}

/**
 * Access Denied page displayed when a user attempts to access
 * a route they don't have permission for.
 */
export const AccessDeniedPage: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const state = location.state as AccessDeniedState | null;

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="flex flex-col items-center text-center max-w-md">
        {/* Lock Icon */}
        <div className="flex items-center justify-center w-20 h-20 rounded-full mb-6 bg-default-100">
          <Icon className="w-10 h-10 text-brand-primary" icon="solar:lock-keyhole-bold" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold mb-2 text-brand-primary">{t("Access Denied")}</h1>

        {/* Message */}
        <p className="text-default-500 mb-8">{t("Access Denied Message")}</p>

        {/* Debug info in development */}
        {state?.attemptedRoute && import.meta.env.DEV && (
          <p className="text-xs text-default-400 mb-4">Attempted: {state.attemptedRoute}</p>
        )}
      </div>
    </div>
  );
};
